import { render } from "./Festival.vue?vue&type=template&id=32fba938&scoped=true"
import script from "./Festival.vue?vue&type=script&lang=js"
export * from "./Festival.vue?vue&type=script&lang=js"

import "./Festival.vue?vue&type=style&index=0&id=32fba938&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fba938"]])

export default __exports__